// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as TableLayoutPanel from "../../resources/layout-and-structure/TableLayoutPanel.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PriceRateTableCell from "../Price/PriceRateTableCell.res.js";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";
import * as PriceRetailTableEditCell from "../Price/PriceRetailTableEditCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query prices($filterBy: InputPricesQueryFilter)  {\nprices(first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ntaxIncluded  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            taxIncluded: value$1.taxIncluded,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.taxIncluded;
    let value$6 = value$1.name;
    let value$7 = value$1.id;
    let value$8 = value$1.__typename;
    let node = {
      __typename: value$8,
      id: value$7,
      name: value$6,
      taxIncluded: value$5,
      shop: shop
    };
    let value$9 = value.__typename;
    return {
      __typename: value$9,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let prices = {
    __typename: value$3,
    edges: edges
  };
  return {
    prices: prices
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputPricesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputPricesQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputPricesQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function keyExtractor(row) {
  return row.id + "-retail";
}

let Row = {
  keyExtractor: keyExtractor
};

function tableColumns(purchasePrice, bulkUnit, onRequestPriceUpdate) {
  return [
    {
      key: "retailprice-list",
      name: I18n.t("Price list"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 220
        },
        width: {
          NAME: "fr",
          VAL: 1.5
        }
      },
      render: param => {
        let match = param.data;
        let taxTypename = I18n.t(match.taxIncluded ? "VAT incl." : "VAT excl.");
        return JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: match.name,
              weight: "semibold"
            }),
            JsxRuntime.jsx(Badge.make, {
              children: taxTypename,
              size: "small",
              variation: "neutral"
            })
          ],
          space: "small"
        });
      }
    },
    {
      key: "retailprice-prices",
      name: I18n.t("Retail prices"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        margin: "large"
      },
      render: param => {
        let match = param.data;
        let id = match.id;
        return JsxRuntime.jsx(PriceRetailTableEditCell.make, {
          valueExcludingTax: match.valueExcludingTax,
          valueIncludingTax: match.valueIncludingTax,
          taxIncluded: match.taxIncluded,
          taxRate: match.taxRate,
          purchasePrice: purchasePrice,
          bulkUnit: bulkUnit,
          onChange: valueExcludingTax => onRequestPriceUpdate(id, valueExcludingTax)
        });
      }
    },
    {
      key: "retailprice-marginrate",
      name: I18n.t("Margin rt"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(PriceRateTableCell.make, {
          rateType: "MarginRate",
          valueExcludingTax: Stdlib_Option.getOr(match.valueExcludingTax, 0),
          purchasePrice: purchasePrice,
          taxRate: match.taxRate
        });
      }
    },
    {
      key: "retailprice-markuprate",
      name: I18n.t("Markup rt"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(PriceRateTableCell.make, {
          rateType: "MarkupRate",
          valueExcludingTax: Stdlib_Option.getOr(match.valueExcludingTax, 0),
          purchasePrice: purchasePrice,
          taxRate: match.taxRate
        });
      }
    }
  ];
}

function CatalogVariantEditFormRetailPriceTablePanel(props) {
  let taxRate = props.taxRate;
  let match = CatalogVariantEditForm.useFormState().values;
  let bulk = match.bulk;
  let capacityUnit = match.capacityUnit;
  let purchasePrice = Stdlib_Option.getOr(match.purchasePrice, 0);
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let activeShop = Auth.useActiveShop();
  let queryResults = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    filterBy: {
      shopIds: {
        _in: [Stdlib_Option.mapOr(activeShop, "", param => param.id)]
      },
      archived: undefined
    }
  });
  let match$1 = React.useState(() => []);
  let setPrices = match$1[1];
  let prices = match$1[0];
  React.useEffect(() => {
    if (prices.length === 0) {
      let match = queryResults.data;
      if (match !== undefined) {
        let prices$1 = match.prices;
        setPrices(param => prices$1.edges.map(param => {
          let price = param.node;
          return {
            id: price.id,
            name: price.name,
            valueExcludingTax: undefined,
            valueIncludingTax: undefined,
            taxIncluded: price.taxIncluded,
            taxRate: taxRate
          };
        }));
      }
    }
  }, [
    queryResults,
    purchasePrice
  ]);
  ReactUpdateEffect.use1(() => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "VariantPrices",
      _1: param => Stdlib_Array.filterMap(prices, param => {
        let valueIncludingTax = param.valueIncludingTax;
        let valueExcludingTax = param.valueExcludingTax;
        if (valueExcludingTax !== undefined && valueIncludingTax !== undefined && valueExcludingTax > 0) {
          return {
            priceId: param.id,
            valueIncludingTax: valueIncludingTax,
            valueExcludingTax: valueExcludingTax
          };
        }
      })
    });
  }, [prices]);
  let onRequestPriceUpdate = React.useCallback((priceId, nextValueExcludingTax) => setPrices(prices => prices.map(priceData => {
    if (priceData.id === priceId) {
      return {
        id: priceData.id,
        name: priceData.name,
        valueExcludingTax: nextValueExcludingTax,
        valueIncludingTax: Stdlib_Option.map(nextValueExcludingTax, __x => PriceCalculator.Retail.Tax.add(__x, taxRate)),
        taxIncluded: priceData.taxIncluded,
        taxRate: priceData.taxRate
      };
    } else {
      return priceData;
    }
  })), []);
  let columns = React.useMemo(() => tableColumns(purchasePrice, capacityUnit !== undefined && bulk ? capacityUnit : undefined, onRequestPriceUpdate), [
    purchasePrice,
    capacityUnit,
    bulk
  ]);
  return JsxRuntime.jsx(TableLayoutPanel.make, {
    title: I18n.t("Retail price"),
    description: I18n.t("Enter the retail prices for each of your price lists."),
    children: queryResults.data !== undefined ? JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: prices
          }
        },
        columns: columns,
        keyExtractor: keyExtractor
      }) : (
        queryResults.loading ? JsxRuntime.jsx(Placeholder.make, {
            status: "Loading"
          }) : JsxRuntime.jsx(Placeholder.make, {
            status: "Error"
          })
      )
  });
}

let make = React.memo(CatalogVariantEditFormRetailPriceTablePanel);

export {
  Query,
  Row,
  tableColumns,
  make,
}
/* query Not a pure module */
